import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from 'common/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
    private toastShown = false;

    constructor(
        private toastService: ToastService,
        private translateService: TranslateService
    ) {}

    intercept(request: HttpRequest<Object>, next: HttpHandler): Observable<HttpEvent<Object>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage: string | undefined;

                switch (error.status) {
                    case 500:
                        errorMessage = 'GENERAL.ERROR_MESSAGES.SERVER_ERROR';
                        break;
                    case 502:
                        errorMessage = 'GENERAL.ERROR_MESSAGES.BAD_GATEWAY';
                        break;
                    default:
                        break;
                }


                if (errorMessage && !this.toastShown) {
                    this.toastShown = true;

                    this.toastService.add({
                        content: this.translateService.instant(errorMessage),
                        theme: 'error',
                        closeable: true,
                        autoClose: true
                    });

                    setTimeout(() => this.toastShown = false, 3000);
                }

                return throwError(error);
            })
        );
    }
}
